<template>
  <v-card>
    <!--Fixme 固定高度在vutify@1.4中已经不可用，会造成父级元素（v-card-title）塌陷-->
    <v-card-title style="height: 80px" class="py-0 my-0">
      <span class="title px-2">{{item[title]}}</span>
      <slot name="subtitle">
        <span class="grey--text">{{subTitle}}</span>
      </slot>
      <slot name="time">
        <v-layout class="pl-4" wrap>
          <v-flex xs6 v-if="updateTime !== undefined">
            <span class="grey--text caption mr-2">上次更新</span>
            <span :class="updateTime ? '':'grey--text'" class="pr-4">{{updateTime || 'N/A'}}</span>
          </v-flex>
          <v-flex xs6 v-if="creationTime !== undefined">
            <span class="grey--text caption mr-2">创建时间</span>
            <span :class="creationTime ? '':'grey--text'" class="pr-4">{{creationTime || 'N/A'}}</span>
          </v-flex>
        </v-layout>
      </slot>
      <v-spacer></v-spacer>
      <slot name="title-actions"></slot>
    </v-card-title>
    <v-card-text>
      <v-container class="py-0" fluid grid-list-md>
        <v-layout :class="opts.length ? 'mb-4': ''" wrap>
          <v-flex :class="opt.layout || 'xs12'" v-for="(opt,i) in opts" :key="i">
            <v-btn flat color="primary" @click="opt.fn" v-if="opt.type==='button'">{{opt.label}}</v-btn>
            <v-text-field
              v-else-if="!opt.textarea"
              :disabled="opt.disabled !== false"
              readonly
              :type="opt.type"
              :label="opt.label"
              :placeholder="opt.placeholder || 'N/A'"
              :prepend-icon="opt.icon || opt.prependIcon"
              :value="formValue(item[opt.key], opt)"
              persistent-hint
              :hint="opt.hint"
            ></v-text-field>
            <v-textarea
              v-else
              :rows="1"
              auto-grow
              :disabled="opt.disabled !== false"
              readonly
              :label="opt.label"
              :placeholder="opt.placeholder || 'N/A'"
              :prepend-icon="opt.icon || opt.prependIcon"
              :value="formValue(item[opt.key], opt)"
              persistent-hint
              :hint="opt.hint"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <slot name="append"></slot>
        <slot name="imgs"></slot>
      </v-container>
      <slot></slot>
    </v-card-text>
    <slot name="card-actions"></slot>
  </v-card>
</template>

<script>
export default {
  name: 'infoCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
    opts: {
      type: Array,
      required: true,
    },
    title: {type: String, default: 'name'},
    subTitle: {type: String, default: ''},
    updateTime: {type: String},
    creationTime: {type: String},
  },
  computed: {
    formValue () {
      return (v, opt) => {
        if (opt.f instanceof Function) {
          return opt.f(v)
        }
        else {
          return v
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
